import React from "react";

const Divider = () => {
  return <div className="w-full my-4 border-b"></div>;
};

export default Divider;
